import { graphql } from "gatsby";
import * as React from "react";
import { List, Item, Image, Table, Header, Container, Segment, Icon } from "semantic-ui-react";
import {withLayout} from "../components/Layout";
import { ContentfulPersonConnection, schedule_4 } from "../graphql-types";

interface AboutProps extends LayoutProps {
  data: {
    person: ContentfulPersonConnection;
  };
  pageContext: {
    tag?: string; // only set into `templates/tags-pages.tsx`
  };
}

const AboutPage = (props: AboutProps) => {
  const person = props.data.person.edges[0].node;
  const {name, office, phone, title, company, email} = person;
  const schedule: schedule_4[] = person.schedule.childContentfulSemesterScheduleScheduleJsonNode.schedule;
  const semester = person.schedule.semester;
  const image = person.image.file.url;

  const scheduleTable =
    <Table celled striped unstackable>
      <Table.Header>
        <Table.Row> 
          <Table.HeaderCell>Course</Table.HeaderCell>
          <Table.HeaderCell>Monday</Table.HeaderCell>
          <Table.HeaderCell>Tuesday</Table.HeaderCell>
          <Table.HeaderCell>Wednesday</Table.HeaderCell>
          <Table.HeaderCell>Thursday</Table.HeaderCell>
          <Table.HeaderCell>Friday</Table.HeaderCell>
          <Table.HeaderCell>Location</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {schedule.map ((aclass) => {
        return <Table.Row key={aclass.Item}>
          <Table.Cell><b>
            {aclass.Item}</b>
          </Table.Cell>
          {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => {
            return <Table.Cell key={day}>
              {aclass.Days.map((classDay) => {
              if (classDay.Day === day) { return classDay.Time; }
            })}
            </Table.Cell>; })}
          <Table.Cell>
            {aclass.Location}
          </Table.Cell>
        </Table.Row>;
        })}
      </Table.Body>
    </Table>;

  return (
    <Container text>
      <Segment>
      <Item.Group>
      <Item>
        <Item.Content>
          <Item.Header as="h1">
            {name}
          </Item.Header>
          <Item.Meta>
            {title}<br />
            {company}
          </Item.Meta>
          <Item.Description className="noclear">
            <List className="noclear">
            <List.Item className="noclear">
              <List.Icon name="at" />
              <List.Content>{email}</List.Content>
            </List.Item>
            <List.Item className="noclear">
              <List.Icon name="phone" />
              <List.Content>
                {phone}
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon name="map pin" />
              <List.Content>
                {office}
              </List.Content>
            </List.Item>
          </List>
          </Item.Description>

        </Item.Content>
        <Item.Image>
          <Image src={"http:" + image} size="small" style={{borderRadius: "500em"}} />
        </Item.Image>

      </Item>
      </Item.Group>
      </Segment>

      <Header as="h2">
        Schedule for {semester}
      </Header>
      <Segment basic style={{overflowX: "auto"}}>
        {scheduleTable}
      </Segment>

      <div dangerouslySetInnerHTML={{
        __html: person.shortBio.childMarkdownRemark.html,
      }} />
    </Container>
  );
};

export default withLayout(AboutPage);

export const pageQuery = graphql`
query Person {
  person: allContentfulPerson {
    edges {
      node {
        name
        title
        company
        office
        email
        phone
        image {
          file {
            url
            fileName
            contentType
          }
        }
        schedule {
          semester
          childContentfulSemesterScheduleScheduleJsonNode {
            schedule {
              Item
              Location
              Days {
                Day
                Time
              }
            }
          }
        }
        shortBio {
          childMarkdownRemark {
            html
          }
        }
        updatedAt
      }
    }
  }
}
`;
